import { Switch } from '@mui/material'
import { SyntheticEvent, useState } from 'react'

interface IProps {
  id: string
  initValue: boolean
  disabled?: boolean
  handlePublicChange: (name: string, checked: boolean) => void
}

export const PublicSwitch = ({ initValue, handlePublicChange, id, disabled = false }: IProps) => {
  const [value, setValue] = useState(initValue)

  const handleSwitchChange = (_event: SyntheticEvent<Element, Event>, checked: boolean) => {
    setValue(checked)
    handlePublicChange(id, checked)
  }

  return <Switch size="small" checked={value} disabled={disabled} onChange={handleSwitchChange} />
}
